import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { hexToRgba } from 'src/app/common/colorUtils';
import { LabelModel } from 'src/app/models/api/common';
import { EditLabelDialogComponent, EditLabelDialogInputData } from '../edit-label-dialog/edit-label-dialog.component';

@Component({
  selector: 'app-select-label-dialog',
  templateUrl: './select-label-dialog.component.html',
  styleUrls: ['./select-label-dialog.component.scss'],
})
export class SelectLabelDialogComponent {
  @Input() public label: LabelModel;
  @Input() public labelSelected = false;
  @Input() public editable = true;
  @Input() public isCustomLabel = false;
  @Input() public isOperator = false;
  @Output() public labelSelectedEventEmitter: EventEmitter<LabelModel> = new EventEmitter<LabelModel>();
  @Output() public labelUnselectedEventEmitter: EventEmitter<LabelModel> = new EventEmitter<LabelModel>();

  constructor(
    public dialogRef: MatDialogRef<SelectLabelDialogComponent>,
    public matDialog: MatDialog
  ) {}

  public onLabelSelected() {
    this.labelSelected = !this.labelSelected;
    const emitter = this.labelSelected ? this.labelSelectedEventEmitter : this.labelUnselectedEventEmitter;
    emitter.emit(this.label);
  }

  public getLabelTransparentBackgroundColor(): string {
    return hexToRgba(this.label.color, 0.3);
  }

  public editLabelClick() {
    if (!this.isOperator) return;
    this.dialogRef.close();
    this.matDialog.open(EditLabelDialogComponent, {
      data: {
        label: {
          id: this.label.id,
          displayName: this.label.displayName,
          color: this.label.color,
        } as LabelModel,
      } as EditLabelDialogInputData,
      disableClose: false,
      autoFocus: false,
      panelClass: 'sidepanel-dialog-container',
      width: '350px',
    });
  }
}
